import { STATIC_IMAGES } from '../../utils/images-mapping';
import styles from './styles';
import { useScreen } from '@ebh/capsule/hooks';
const GuestNavbar = () => {
  const isMobile = !useScreen('md');

  return (
    <div
      css={[
        styles.container,
          (isMobile
            ? { display: 'none' }
            : { background: 'white', borderBottom: '1px solid gray' }),
      ]}
    >
      <img
        src={STATIC_IMAGES.VIDAL_LOGO_DARK}
        alt="Vidal_logo"
        css={styles.logo}
      />
    </div>
  );
};

export default GuestNavbar;
